<template>
  <div class="footer">
    <p>Powered by SOFT TEAM Consulting  v. {{ this.version }}   {{ this.signal }} </p>
  </div>
</template>
<script>
    export default {
        data: function () {
            return {
                version: process.env.VUE_APP_VERSION,
                signal : ''
            };
        },
        watch: {
          signal: function () {
            console.log(navigator.connection.effectiveType);
            this.signal =  navigator.connection.effectiveType
          },
        },
        methods:{
        //   handlerPushErrorOrder(){
        //     this.$store.dispatch('orders/launchOfflineOrders');
        //   },
        }
    }
</script>
<style scoped>
    .footer{
        text-align:center;
        margin:auto;
        font-size:10px;
    }
</style>
